import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ViewportErrorFallback } from './ViewportErrorFallback';

interface Props {
  children: ReactNode;
  onReset?: () => void;
}

interface State {
  hasError: boolean;
}

export class ViewportErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('3D viewport error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      return <ViewportErrorFallback onRetry={this.handleReset} />;
    }

    return this.props.children;
  }
}
